<template lang="pug">
div
    //- .select is a global style defined in forms.styl
    div(class="select capitalize")
        select(
            :disabled="select.isDisabled"
            v-model="selectedValue"
            :class="selectClass"
            :aria-label="selectOptions[0].text"
        )
            option(
                v-for="option in selectOptions"
                :value="option.value"
                :disabled="option.isDisabled"
                v-html="option.text"
            )

    div(v-if="select.hasError" class="text-danger") This {{ select.type }} is not valid for your current vehicle.
</template>
<script>
export default {
    props: {
        select: {
            type: Object,
            required: true,
        },
        currentValue: {
            type: [String, Number],
            default: '',
        },
        disableHighlight: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        selectOptions() {
            return this.select.options.filter((option) => !option.isHidden)
        },
        selectedValue: {
            get() {
                return this.currentValue
            },
            set(value) {
                this.$emit('changed', {
                    sourceType: this.select.type,
                    newValue: value,
                })
            },
        },
        selectClass() {
            // -needsSelection and -hasSelection are global css states and used by alert.js
            return {
                '-needsSelection':
                    !this.disableHighlight && this.currentValue === -1 && !this.select.isDisabled,
                '-hasSelection': this.currentValue !== -1 && !this.select.isDisabled,
                '-hasError': this.select.hasError,
            }
        },
    },
}
</script>

<style lang="stylus" scoped>
// Needs to override forms.styl
.-hasError
    color theme('colors.danger.DEFAULT')
    border-color theme('colors.danger.DEFAULT')
</style>
